<template>
  <div class="gneyai-rive">
    <canvas ref="canvas" :width="size" :height="size" :style="{ width: size + 'px', height: size + 'px' }"></canvas>
  </div>
</template>

<script>
import { Rive } from "@rive-app/webgl2";

export default {
  name: "FTSGneyAi",
  props: {
    size: {
      type: Number,
      default: 60,
    },
    type: {
      type: String,
      default: "idle", // "idle" | "thinking" | "rest"
      validator: (val) => ["idle", "thinking", "rest"].includes(val),
    },
  },
  mounted() {
    let srcFile = "./pi/rive/gney-ai-idle.riv"; // default

    if (this.type === "thinking") {
      srcFile = "./pi/rive/gney-ai-thinking.riv";
    } else if (this.type === "rest") {
      srcFile = "./pi/rive/gney-ai-rest.riv"; // 新增 rest 动画
    }

    const r = new Rive({
      src: srcFile,
      canvas: this.$refs.canvas,
      autoplay: true,
      stateMachines: "State Machine 1",
      onLoad: () => {
        r.resizeDrawingSurfaceToCanvas();
      },
    });
  },
};
</script>

<style scoped>
.gneyai-rive {
  display: flex;
  align-items: center;
  justify-content: center;
}

.global-gney-ai { 
  cursor: pointer;
}
</style>
